export const CONSTANTS = {
  FULL_VIEW: 'FULL_VIEW',
  EDITOR_VIEW: 'EDITOR_VIEW',
  APP_VIEW: 'APP_VIEW',
  SAND_BOX: 'SAND_BOX',
  APP_LAUNCH: 'APP_LAUNCH',
  LS_PREFIX: 'SK_',
  LAUNCH_SETTINGS: 'LSETTINGS',
  INPUT_REGEX : /^[A-Za-z0-9\-_!#$^.@]+$/,
  WP_INPUT_REGEX : /^[A-Za-z0-9!@#$%^&*\(\)-_\[\]\{\}\<\>\~`+=,\.;:\/\?\|']+/,  
  WP_INPUT_REGEX_STR : "^[A-Za-z\u00c0-\u02AF0-9!@#$%^&*\\(\\)\\-_\\[\\]\\{\\}\\<\\>\\~`+=,\\.;:\\/\\?\\|']+$",  
  WP_INPUT_ALLOW_CHARS : "A-Za-z0-9!@#$%^&*()-_ []{}<>~`+=,.;:/?|'",
  USER_NAME_MIN : 5,
  USER_NAME_MAX : 50,
  PASSWORD_MIN : 8,
  PASSWORD_MAX : 128,
  EMAIL_MIN : 10,
  EMAIL_MAX : 50,
};

export const APP_CFG = "appConfiguration";
export const DOMAIN_CFG = "domainConfiguration";
export const ASSET_CFG_KEY = "ASSET_CFG";
export const VIEW_DATA = "viewData";
export const ERROR_VIEW_NAME = "error";
export const CONTENT_VIEW_NAME = "content";
export const LECTURE_VIEW_NAME = "lecture";
export const DOCUMENTATION_VIEW_NAME = "documentation";
export const EDITOR_VIEW_NAME = "editor";
export const LOADING_VIEW_NAME = "loading";
export const LAUNCH_VIEW_NAME = "launch";
export const EMBED_VIEW_NAME = "embed";
export const LIST_VIEW_NAME = "list";
export const PORTAL_VIEW_NAME = "portal";
export const ACHIEVEMENTS_VIEW_NAME = "achievements";
export const QUEST_VIEW_NAME = "quest";
export const CHAT_VIEW_NAME = "chat";
export const DATA_VIEW_NAME = "data";

export const PARTY_USER_STATE = "partyUserState";

export const THEME = "theme";
export const PROJECT_COORDINATES = "projectCoordinates";
export const RESULT_CODE = "resultCode";
export const NEXT_PROJECT_BUTTON = "nextProjectButton";
export const QUESTION_MODAL_STATE = "questionModalState";
export const SPECIAL_QUESTION_MODAL_STATE = "specialQuestionModalState";
export const STEP_POPPER = "stepPopper";
export const POPPER_HELPER = "popperHelper";
export const HELP_AREA_STATE = "helpArea";
export const TASK_AREA_STATE = "taskArea";
export const SOLUTION_AREA_STATE = "solutionArea";
export const ASSETS_LIB_TABS = "assetsLibTabs";
export const CODE_EDITOR = "codeEditor";
export const SHARE_MODAL_STATE = "shareModal";
export const SHARE_PROJECT_STATE = "shareProject";
export const LOGIN_REG_MODAL_STATE = "loginRegisterModal";
export const STATS_STATE = "statsState";
export const TOAST_STATE = "toastState";
export const DATA_LIST = "dataList";
export const BACKEND_STATE = "backendState";
export const ONBOARDING_STATE = "onboarding";
export const ERROR_HELP_STATE = "errorHelp";
export const ACHIEVEMENTS_STATE = "achievements";

export const SETTINGS_DATA_KEY = CONSTANTS.LS_PREFIX + CONSTANTS.LAUNCH_SETTINGS;
export const ACHIEVEMENTS_DATA_KEY = CONSTANTS.LS_PREFIX + "Achievements";
export const ONBOARDING_STEP_KEY = CONSTANTS.LS_PREFIX + "OnboardingStep";
export const LAST_STEP_KEY = CONSTANTS.LS_PREFIX + "FinishedStep";
export const HAS_CODING_CARDS_KEY = CONSTANTS.LS_PREFIX + "HasCodingCards";

export const TASK_MODE_CARD = "CARD";
export const TASK_MODE_STEPS = "STEPS";
